import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

import Close from 'images/close.svg'

const ErrorModal = ({ closeModal, record, translate }) => (
  <Modal closeModal={closeModal} className='tracking-monitor-errorModal'>
    <p>
      <img src={Close} />
    </p>
    <h3>
      <strong>{translate('totem.trackingMonitor.modal.error.title')}</strong>
    </h3>
    <p>
      {`${translate('totem.trackingMonitor.modal.error.content.1')} `}
      <strong>{record.header.orderNumber}</strong>
      {` ${translate('totem.trackingMonitor.modal.error.content.2')}`}
    </p>
    <p>
      <span>{translate('totem.trackingMonitor.modal.error.content.3')}</span>
    </p>

    <Row className='margin-top-quadruple'>
      <Col xs={4} xsOffset={4}>
        <button
          className='button button-primary button-full'
          onClick={closeModal}
        >
          {translate('ok_button')}
        </button>
      </Col>
    </Row>
  </Modal>
)

ErrorModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

export default ErrorModal
